

























import { defineComponent } from '@nuxtjs/composition-api'
import { useQuery, useResult } from '@/composables/blkApollo'
import { OfferType, offersQuery } from '@/queries/offersQuery'
import BlkOffersCard from '@/components/offers/BlkOffersCard.vue'
import getOfferBannerImg from '@/utils/getOfferBannerImg'
export default defineComponent({
  auth: false,
  components: {
    BlkOffersCard
  },
  setup() {
    const { result, loading } = useQuery(offersQuery, null, {
      fetchPolicy: 'cache-first'
    })
    const offers = useResult(result, [], ({ offers: incomingOffers }) =>
      incomingOffers.filter((offer: OfferType) =>
        ['closed', 'paid'].includes(offer.status)
      )
    )
    return { offers, loading, getOfferBannerImg }
  }
})
